export type PartnerSpotlightEntry = {
  id: string;
  file: string;
  alt: string;
  /** Optional visual scale (1 = default). >1 boosts thin wordmarks; <1 tames heavy marks. */
  logoDisplayScale?: number;
};

export function partnerSpotlightLogoSrc(file: string): string {
  const base = (process.env.PUBLIC_URL ?? "").replace(/\/$/, "");
  return `${base}/partner_logos/${file}`;
}

export const PARTNER_SPOTLIGHT_ENTRIES: PartnerSpotlightEntry[] = [
  {
    id: "american-express",
    file: "american-express-v2.svg",
    alt: "American Express",
  },
  { id: "awardco", file: "awardco-v2.svg", alt: "Awardco" },
  { id: "chase", file: "chase-v2.svg", alt: "Chase" },
  { id: "crunchtime", file: "crunchtime-v2.svg", alt: "Crunchtime" },
  { id: "daily-pay", file: "daily-pay-v2.svg", alt: "DailyPay" },
  { id: "deel", file: "deel.webp", alt: "Deel" },
  {
    id: "employee-navigator",
    file: "employee-navigator-v2.svg",
    alt: "Employee Navigator",
    logoDisplayScale: 1.12,
  },
  { id: "evans-national", file: "evans-national.png", alt: "Evans National" },
  {
    id: "fidelity",
    file: "fidelity-v2.svg",
    alt: "Fidelity",
    logoDisplayScale: 0.92,
  },
  {
    id: "fourth",
    file: "fourth-v2.svg",
    alt: "Fourth",
    logoDisplayScale: 0.93,
  },
  { id: "hcss", file: "hcss-v2.svg", alt: "HCSS", logoDisplayScale: 1.22 },
  {
    id: "healthequity",
    file: "healthequity-v2.svg",
    alt: "HealthEquity",
    logoDisplayScale: 1.45,
  },
  { id: "hi-bob", file: "hi-bob-v2.svg", alt: "HiBob" },
  {
    id: "hr-acuity",
    file: "hr-acuity-v2.svg",
    alt: "HR Acuity",
    logoDisplayScale: 1.2,
  },
  {
    id: "intuit-quickbooks",
    file: "intuit-quickbooks-v2.svg",
    alt: "Intuit QuickBooks",
  },
  { id: "john-hancock", file: "john-hancock-v2.svg", alt: "John Hancock" },
  { id: "lightspeed", file: "lightspeed-v2.svg", alt: "Lightspeed" },
  { id: "multiplier", file: "multiplier-v2.svg", alt: "Multiplier" },
  { id: "par", file: "par-v2.svg", alt: "PAR Technology" },
  { id: "payactiv", file: "payactiv-v2.svg", alt: "Payactiv" },
  { id: "paylocity", file: "paylocity-v2.svg", alt: "Paylocity" },
  { id: "rave-mobile", file: "rave-mobile-v2.svg", alt: "Rave Mobile Safety" },
  { id: "retailstack", file: "retailstack-v2.svg", alt: "Retailstack" },
  { id: "sap-concur", file: "sap-concur-v2.svg", alt: "SAP Concur" },
  {
    id: "secured-gp",
    file: "secured-gp-v2.svg",
    alt: "Secured GiftPay",
  },
  { id: "toast", file: "toast-v2.svg", alt: "Toast" },
  {
    id: "united-hc",
    file: "united-hc-v2.svg",
    alt: "UnitedHealthcare",
  },
  { id: "vanguard", file: "vanguard-v2.svg", alt: "Vanguard" },
  {
    id: "vector-solutions",
    file: "vector-solutions-v2.svg",
    alt: "Vector Solutions",
  },
  { id: "voya", file: "voya-v2.svg", alt: "Voya" },
  { id: "wex", file: "wex-v2.svg", alt: "WEX", logoDisplayScale: 1.12 },
  { id: "workable", file: "workable-v2.svg", alt: "Workable" },
];
